let bubbles = [];
let bubbleCount = 40;
for (let i = 0; i < bubbleCount; i++) {
  bubbles.push(<span key={i}></span>);
}
export default bubbles;
